module.exports = __webpack_public_path__ + "static/MountainView-29528ab535b70bff14d7ef299335d57f.jpg";